<template>
  <d-form @submit.prevent="submit" class="user-edit-password-form" >
    <d-card class="mb-3">
      <d-card-body>
        <d-row>
          <d-col cols="12">
            <form-group v-model="d_data.currentPassword" :error="d_mutation.errors.get('currentPassword')" :label="$t('input.label.current_password')">
              <template #input>
                <password-input v-model="d_data.currentPassword" :placeholder="$t('input.placeholder.current_password')" />
              </template>
            </form-group>
          </d-col>

          <d-col cols="12">
            <form-group v-model="d_data.newPassword" :label="$t('input.label.new_password')">
              <template #input>
                <password-input v-model="d_data.newPassword" :placeholder="$t('input.placeholder.new_password')" />
              </template>
            </form-group>
          </d-col>

          <d-col cols="12">
            <form-group v-model="d_data.confirmPassword" :error="d_customError" :label="$t('input.label.confirm_password')">
              <template #input>
                <password-input v-model="d_data.confirmPassword" :placeholder="$t('input.placeholder.confirm_password')" />
              </template>
            </form-group>
          </d-col>
        </d-row>
      </d-card-body>
    </d-card>

    <div class="text-right mt-3">
      <r-button :error="d_mutation.error" :loading="d_mutation.loading" :success="d_mutation.success">
        {{ $t('button.save_changes') }}
      </r-button>

      <div v-if="d_mutation.errors.has('message')">
        {{ d_mutation.errors.get('message') }}
      </div>
    </div>
  </d-form>
</template>

<script>
import Mutation from '@/library/Mutation';
import PasswordInput from '@/components/common/form/PasswordInput';

export default {
  name: 'user-password-form',
  components: { PasswordInput },
  data () {
    return {
      d_data: {},
      d_mutation: new Mutation(),
      d_customError: '',
    };
  },
  methods: {
    submit () {
      this.d_mutation.reset();
      this.d_customError = '';

      ['currentPassword', 'newPassword', 'confirmPassword'].forEach((prop) => {
        if (!this.d_data[prop] || this.d_data[prop] === null) {
          this.d_mutation.error = true;
          this.d_customError = this.$t('error.unfilled_field');
        }
      });

      if (this.d_mutation.error) {
        return;
      }

      if (this.d_data.newPassword !== this.d_data.confirmPassword) {
        this.d_mutation.error = true;
        this.d_customError = this.$t('error.unmatched_passwords');

        return;
      }

      this.d_mutation.mutate(
        require('@/graphql/users/UpdatePassword.gql'),
        {
          currentPassword: this.d_data.currentPassword,
          newPassword: this.d_data.newPassword,
        }
      );
    }
  }
}
</script>
